import { CloseCircleFilled, ExclamationCircleFilled, ExclamationCircleOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import { FC, useCallback } from "react";
import { MsgModalModel } from "../../hooks/use-message-modal-helper";
import { useKeyboardModalProps } from "../../hooks/useKeyboardModalProps";
import { colorError, colorInfo, colorWarning, content, detail, icon, iconImg, message, messageContainer, title } from "./styles";

const ConfirmationIcon = <ExclamationCircleOutlined style={{ ...iconImg, ...colorWarning }}/>;
const ErrorIcon = <CloseCircleFilled style={{ ...iconImg, ...colorError }}/>;
const InfoIcon = <InfoCircleOutlined style={{ ...iconImg, ...colorInfo }}/>;
const WarningIcon = <ExclamationCircleFilled style={{ ...iconImg, ...colorWarning }}/>;

const renderIcon = (msgModalData?: MsgModalModel) => {
  if (!msgModalData) return <></>;
  switch (msgModalData.type) {
    case "CONFIRMATION":
      return ConfirmationIcon;
    case "ERROR":
      return ErrorIcon;
    case "INFO":
      return InfoIcon;
    case "WARNING":
      return WarningIcon;
  }
};

export interface MessageModalProps {
  msgModalData?: MsgModalModel;
  isOpen?: boolean;
  onClose: (ok: boolean) => void;
}

const cancelButtonProps = { style: { display: "none" } };
export const MessageModal: FC<MessageModalProps> = ({ msgModalData, isOpen, onClose }) => {
  const onCancel = useCallback(
    () => onClose(false),
    [onClose],
  );
  const onOk = useCallback(
    () => onClose(true),
    [onClose],
  );

  const modalProps = useKeyboardModalProps({
    cancelButtonProps: msgModalData?.type !== "CONFIRMATION" ? cancelButtonProps : undefined,
    cancelText: msgModalData?.cancelText,
    centered: true,
    closeIcon: false,
    okText: msgModalData?.okText,
    onCancel,
    open: isOpen === undefined ? Boolean(msgModalData) : isOpen,
  }, onOk);

  return (
    <Modal {...modalProps}>
      <div style={content}>
        <div style={icon}>{renderIcon(msgModalData)}</div>
        <div style={messageContainer}>
          <div>
            <div style={title}>{msgModalData?.title}</div>
            <div style={message}>{msgModalData?.message}</div>
          </div>
          <div style={detail}>{msgModalData?.detail}</div>
        </div>
      </div>
    </Modal>
  );
};
